import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useAlooChat() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin") || location.pathname.startsWith("/auth");
  const isWorkPage = location.pathname === "/work" || location.pathname === "/ar/work";

  useEffect(() => {
    const applyWidgetLayout = () => {
      const frame = document.querySelector('[id^="aloochat"]') as HTMLElement | null;
      if (!frame) return;

      frame.style.display = "";

      if (isWorkPage && window.innerWidth < 768) {
        frame.style.bottom = "1rem";
        frame.style.right = "0.875rem";
        frame.style.transform = "scale(0.92)";
        frame.style.transformOrigin = "bottom right";
      } else {
        frame.style.bottom = "";
        frame.style.right = "";
        frame.style.transform = "";
        frame.style.transformOrigin = "";
      }
    };

    if (isAdmin) {
      const existing = document.querySelector('script[src*="aloochat"]');
      if (existing) existing.remove();
      const w = window as any;
      if (w.alooChatSDK?.toggle) {
        const frame = document.querySelector('[id^="aloochat"]');
        if (frame) (frame as HTMLElement).style.display = "none";
      }
      return;
    }

    const w = window as any;
    const runApplyWidgetLayout = () => {
      applyWidgetLayout();
      window.setTimeout(applyWidgetLayout, 300);
      window.setTimeout(applyWidgetLayout, 900);
    };

    if (document.querySelector('script[src*="aloochat"]')) {
      runApplyWidgetLayout();
      const onResize = () => applyWidgetLayout();
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }

    const BASE_URL = "https://cx.aloochat.ai";
    const script = document.createElement("script");
    script.src = BASE_URL + "/packs/js/sdk.js";
    script.async = true;
    script.onload = () => {
      w.alooChatSDK?.run({
        websiteToken: "LtNvvA3waPjdt3MGHakDgVef",
        baseUrl: BASE_URL,
      });
      runApplyWidgetLayout();
    };
    document.body.appendChild(script);

    const onResize = () => applyWidgetLayout();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [isAdmin, isWorkPage]);
}
